import uuid from 'uuid';
const subscribers = {};
export function subscribe(func) {
  const id = uuid.v4();
  subscribers[id] = func;
  return function() {
    delete subscribers[id];
  };
}
export function publish(value) {
  Object.values(subscribers).forEach(func => func(value));
}



// WEBPACK FOOTER //
// ./src/pubsubEngine.js